import { DateTime, Effect, Layer } from 'effect';
import type { Cause, Config } from 'effect';

import { TimezoneConfig } from '../../config/clock';

export const ZoneLayer: Layer.Layer<
  DateTime.CurrentTimeZone,
  Config.ConfigError | Cause.IllegalArgumentError
> = TimezoneConfig.pipe(Effect.map(DateTime.layerCurrentZoneNamed), Layer.unwrap);
